import styled from 'styled-components';
import { Menu } from 'components/atoms/dropdown';
import { Empty } from 'components/atoms/empty';
import {
  Container,
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
} from 'components/atoms/empty-state';

export const ComaparisonWrapper = styled.div`
  display: flex;
  height: calc(100vh - 104px);
  flex-grow: 1;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const DividerBar = styled.div`
  height: 100%;
  width: 1px;
  border-left: 1px solid var(--gray-30);
`;

export const OverlayWrapper = styled.div`
  height: calc(100vh - 154px);
  width: 100%;
  flex-grow: 1;
`;

export const CommentsHeader = styled.div`
  margin-bottom: var(--spacing-03);
`;

export const ComaparisonModeWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const CommentsSectionWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
`;

export const CommentsSection = styled.div<{ isClose: boolean }>`
  background: var(--coolest-gray-10);
  overflow-y: auto;
  scroll-behavior: smooth;
  padding: ${(props) => (!props.isClose ? 'var(--spacing-04)' : '0')};
  padding-right: ${(props) => (!props.isClose ? 'var(--spacing-05)' : '0')};
  width: ${(props) => (props.isClose ? '0' : '550px')};
  overflow-x: hidden;
  transition: all 0.5s cubic-bezier(0, 0, 0.3, 1);
`;

export const CommentsText = styled.div`
  font-weight: var(--heading-4-weight);
  font-size: var(--spacing-04);
  color: var(--gray-70);
  margin-left: var(--spacing-05);
`;

export const CommonDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HideResolvedText = styled.div`
  font-weight: var(--heading-4-weight);
  font-size: var(--spacing-04);
  color: var(--blue-60);
  cursor: pointer;
`;

export const MenuItem = styled(Menu.Item)`
  display: flex;
  justify-content: space-between;
`;

export const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: var(--zindex-popover-high);
  background-color: var(--white-90);
`;

export const StyledDiv = styled.div`
  height: 100%;
  width: 100%;
  flex-grow: 1;
`;

export const StyledEmpty = styled(Empty)`
  justify-content: center;
  height: max-content;
  flex-grow: 1;
`;

export const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  && {
    padding: var(--spacing-08) var(--spacing-06) var(--spacing-05);
  }
  ${Container} {
    width: auto;
    max-width: max-content;

    ${EmptyState.Title}, ${EmptyState.Message} {
      width: 100%;
    }
  }
`;

export const ShowResolvedText = styled.div`
  font-weight: var(--heading-4-weight);
  font-size: var(--spacing-04);
  margin-top: var(--spacing-05);
  color: var(--blue-60);
  cursor: pointer;
`;
